import { Component, Inject } from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material';

@Component({
  selector: 'app-request-email-dialog',
  templateUrl: './request-email-dialog.component.html', 
  styleUrls: ['./request-email-dialog.component.css']
})
export class RequestEmailDialogComponent {

  constructor(public dialogRef: MatDialogRef<RequestEmailDialogComponent>) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
      
  submitForm(): void {
    console.log('Submitting form without email address.');
    this.dialogRef.close(false);
  }
  
  provideEmail(): void {
    console.log('User is going to provide email; not submitting form.');
    this.dialogRef.close(true);
  }
} 
